export default __webpack_public_path__ + "static/media/video.31d6cfe0.svg";